import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { TipoVeiculoService } from '../services/tipo-veiculo.service';

@Component({
	selector: 'app-tipo-veiculo-edit',
	templateUrl: './tipo-veiculo-edit.component.html',
	styleUrls: ['./tipo-veiculo-edit.component.css'],
	animations: [loadingFade]
})
export class TipoVeiculoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public tipo_veiculo_id = null;

	public formTipoVeiculo: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private tipoVeiculoSvc: TipoVeiculoService,
				private location: Location,
				private router: Router,) { }

	ngOnInit() {
		this.criaForm();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.tipo_veiculo_id = params.id;
				// pega dados a partir do id
				this.tipoVeiculoSvc.getTipoVeiculo(params.id).then((data: any) => {
					this.preencheForm({
						tipo_veiculo_id: data.tipo_veiculo_id,
						tipo_veiculo_nome: data.tipo_veiculo_nome
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formTipoVeiculo = this.fb.group({
			tipo_veiculo_id: null,
			tipo_veiculo_nome: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formTipoVeiculo.setValue(dados);
	}

	enviaTipoVeiculo() {
		if (this.formTipoVeiculo.valid) {
			this.submitting = true;

			let toSend = this.formTipoVeiculo.value;

			if (this.tipo_veiculo_id === null) { // criar
				this.tipoVeiculoSvc.criaTipoVeiculo(toSend).then((data) => {
					console.log('resp', data);
					this.router.navigate(['home/tiposveiculo']);
				}).catch(err => {
					console.log(err);
				});
			}
			else { // editar
				this.tipoVeiculoSvc.editaTipoVeiculo(toSend).then((data) => {
					console.log('resp', data);
					this.router.navigate(['home/tiposveiculo']);
				}).catch(err => {
					console.log(err);
				});
			}
		}
	}

	invalid(nome) {
		let input = this.formTipoVeiculo.get(nome);
		return input.touched && input.invalid;
	}

	voltar() {
		this.location.back();
	}
}
